import { render, staticRenderFns } from "./Act004MinigameDialog.vue?vue&type=template&id=d814c5e6&scoped=true"
import script from "./Act004MinigameDialog.vue?vue&type=script&lang=js"
export * from "./Act004MinigameDialog.vue?vue&type=script&lang=js"
import style0 from "./Act004MinigameDialog.vue?vue&type=style&index=0&id=d814c5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d814c5e6",
  null
  
)

export default component.exports